import { Router } from '@angular/router';
import { KeycloakService } from '../services/keycloak.service';
import { ModalService } from '../services/modal.service';
import { Campaign } from '../models/campaign.model';

// correction quand le date picker est utilisé
export function correctDate(date: Date): Date {
  let time: number = date.getTime();
  if (date.getHours() === 0) {
    time -= date.getTimezoneOffset() * 60000;
    return new Date(time);
  }
  return date;
}

// Backend LocalDate fields require "YYYY-MM-DD". Date.toJSON() emits full ISO
// datetime, which Jackson's LocalDateDeserializer rejects with 400.
export function toLocalDateString(value: Date | string | null | undefined): string | null {
  if (value == null) {
    return null;
  }
  if (typeof value === 'string') {
    return value.split('T')[0];
  }
  const yyyy = value.getFullYear();
  const mm = String(value.getMonth() + 1).padStart(2, '0');
  const dd = String(value.getDate()).padStart(2, '0');
  return `${yyyy}-${mm}-${dd}`;
}

export function showErrorMessage(modal: ModalService, message: string): Promise<void> {
  return modal.alert(message);
}

export function extractErrorMessage(error: any, defaultMessage: string): string {
  if (!error) {
    return defaultMessage;
  }

  if (typeof error === 'string') {
    return error;
  }

  if (error.errorMessage && typeof error.errorMessage === 'string') {
    return error.errorMessage;
  }

  if (error.message && typeof error.message === 'string' && error.message !== '') {
    return error.message;
  }

  let parsedError: any = tryJson(error);

  if (!parsedError && error && error.error) {
    // HttpClient stores parsed body in error.error
    parsedError = error.error;
  }

  if (parsedError) {
    if (typeof parsedError === 'string') {
      return parsedError;
    }

    if (parsedError.errorMessage && typeof parsedError.errorMessage === 'string') {
      return parsedError.errorMessage;
    }

    if (parsedError.message && typeof parsedError.message === 'string') {
      return parsedError.message;
    }
  }

  return defaultMessage;
}

export function toNumber(value: any): number | null {
  if (value === null || value === undefined) {
    return null;
  }

  if (typeof value !== 'number') {
    const fValue = parseFloat(String(value).replace(',', '.'));
    if (isNaN(fValue)) {
      return null;
    }
    return fValue;
  } else {
    return value;
  }
}

export function toInteger(value: any): number | null {
  const fValue = toNumber(value);
  if (fValue === null) {
    return fValue;
  }
  return Math.round(fValue);
}

export function toBoolean(value: any): boolean | null {
  if (isBooleanValue(value)) {
    return value;
  }
  if (value === null || value === 'null') {
    return null;
  }
  return value === 'true';
}

export function isBooleanValue(value: any) {
  return value === true || value === false;
}

export function isBooleanValueOrStringBoolean(value: any) {
  return value === true || value === false || value === 'true' || value === 'false';
}

export function isTrue(value: any) {
  return value === true || value === 'true';
}

export function isEmpty(value: any) {
  return value === null || value === undefined;
}

export function toNull(value: any) {
  if (value === 'null' || isEmpty(value)) {
    return null;
  }
  return value;
}

export function hasPermission(allowedRoles: string[], redirectTo?: string[], router?: Router): boolean {
  if (!allowedRoles.some((x) => KeycloakService.auth.authz.hasRealmRole(x))) {
    if (redirectTo && router) {
      router.navigate(redirectTo);
    }
    return false;
  }
  return true;
}

export function sortingString(attr: string) {
  return (a: any, b: any) => (!a[attr] ? -1 : !b[attr] ? 1 : a[attr].localeCompare(b[attr]));
}

export function sortingNumber(attr: string) {
  return (a: any, b: any) => (!a[attr] ? -1 : !b[attr] ? 1 : a[attr] - b[attr]);
}

export function currentDateFormatted(separator: string = '-', reverse = true) {
  const today = new Date();
  let dd: number | string = today.getDate();
  let mm: number | string = today.getMonth() + 1;

  const yyyy = today.getFullYear();
  if (dd < 10) {
    dd = '0' + dd;
  }
  if (mm < 10) {
    mm = '0' + mm;
  }

  if (reverse) {
    return yyyy + separator + mm + separator + dd;
  } else {
    return dd + separator + mm + separator + yyyy;
  }
}

export function stob(str: string): boolean | null {
  return str === 'true' ? true : str === 'false' ? false : null;
}

export function tryJson(res: any) {
  try {
    if (typeof res?.json === 'function') {
      return res.json();
    }
    if (typeof res === 'string') {
      return JSON.parse(res);
    }
    return null;
  } catch (ex) {
    return null;
  }
}

export function currentCampaign(campaigns: Campaign[]) {
  campaigns = campaigns.sort(Campaign.compare).reverse();
  return campaigns[0].id;
}
